import { Space } from "antd";

function SuppliersPageV2() {
  return (
    <Space direction={"horizontal"}>
      <Space direction={"vertical"}>
        Suppliers
      </Space>
      <Space direction={"vertical"}>
        Products
      </Space>
    </Space>
  );
}

export default SuppliersPageV2;


